<template>
  <v-dialog :model-value="modelValue" @update:model-value="$emit('update:modelValue', $event)" max-width="400px" persistent>
    <v-card>
      <v-card-title class="text-h5">Expire Trial Early?</v-card-title>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click="$emit('cancel')" data-testid="cancel-button">No (Cancel)</v-btn>
        <v-btn color="red" text @click="$emit('confirm')" data-testid="confirm-button">Yes, Expire Early</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'ExpireTrialModal',
  props: {
    modelValue: {
      type: Boolean,
      required: true,
    },
  },
  emits: ['update:modelValue', 'confirm', 'cancel'],
};
</script>
